import "./styles.scss";

interface FullScreenHeaderProps {
  afterTitle?: React.ReactNode;
  beforeTitle?: React.ReactNode;
  title: React.ReactNode;
}

export const FullScreenHeader = ({
  title,
  beforeTitle,
  afterTitle,
}: FullScreenHeaderProps) => (
  <div className="react-layout-fullscreen-header">
    <div className="react-layout-fullscreen-wrapper">
      {beforeTitle && (
        <div className="react-layout-fullscreen-header-before">
          {beforeTitle}
        </div>
      )}
      <div className="react-layout-fullscreen-header-heading">
        <h1 className="heading-h1">{title}</h1>
        {afterTitle}
      </div>
    </div>
  </div>
);
